import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocSlidesComponent } from './doc-slides.component';
import { NgxGlideModule } from 'ngx-glide';



@NgModule({
  declarations: [
    DocSlidesComponent
  ],
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  bootstrap: [DocSlidesComponent],
  exports: [DocSlidesComponent]
})
export class DocSlidesModule { }
